export type InlineJsonMarkerMatch<T> = {
  prefix: string
  payload: T
  suffix: string
}

export type InlineJsonMarkerParser<T> = {
  parse: (body: string | null | undefined) => T | null
  split: (body: string | null | undefined) => InlineJsonMarkerMatch<T> | null
}

export function splitInlineJsonMarker<T>(
  body: string | null | undefined,
  marker: string,
): InlineJsonMarkerMatch<T> | null {
  if (!body) return null
  const idx = body.indexOf(marker)
  if (idx < 0) return null
  const prefix = body.slice(0, idx).trim()
  const tail = body.slice(idx + marker.length)
  const start = tail.indexOf('{')
  if (start < 0) return null

  let depth = 0
  let inStr = false
  let escape = false
  for (let i = start; i < tail.length; i++) {
    const ch = tail[i]
    if (escape) {
      escape = false
      continue
    }
    if (ch === '\\') {
      escape = true
      continue
    }
    if (ch === '"') {
      inStr = !inStr
      continue
    }
    if (inStr) continue
    if (ch === '{') depth++
    else if (ch === '}') {
      depth--
      if (depth === 0) {
        try {
          return {
            prefix,
            payload: JSON.parse(tail.slice(start, i + 1)) as T,
            suffix: tail.slice(i + 1).trim(),
          }
        } catch {
          return null
        }
      }
    }
  }
  return null
}

export function parseInlineJsonMarker<T>(
  body: string | null | undefined,
  marker: string,
): T | null {
  return splitInlineJsonMarker<T>(body, marker)?.payload ?? null
}

export function inlineJsonMarker<T>(marker: string): InlineJsonMarkerParser<T> {
  return {
    parse: (body) => parseInlineJsonMarker<T>(body, marker),
    split: (body) => splitInlineJsonMarker<T>(body, marker),
  }
}
